<template>
  <div v-if="playingTrack" class="player flex m-a-between s-a-center">
    <button class="player-button" :class="{disabled: !trackLoaded}" @click="handlePlayerClick">
      <svg v-if="!trackProgressObject.currentlyPlaying" width="30" height="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="#454F8C" d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM7 6l8 4-8 4V6z"/></svg>
      <svg v-if="trackProgressObject.currentlyPlaying" width="30" height="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="#454F8C" d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM7 6h2v8H7V6zm4 0h2v8h-2V6z"/></svg>
    </button>
    <progress-bar :progress-object="trackProgressObject"></progress-bar>
    <volume-control :volume="playingTrack.volume"></volume-control>
  </div>
</template>

<script>
import { bus } from "../../main";
import progressBar from "./ProgressBar";
import volumeControl from "./VolumeControl";
export default {
  name: "player",
  components: {progressBar, volumeControl},
  data: () => {
    return {
      trackLoaded: false,
      playingTrack: false,
      trackProgressObject: {
        duration: false,
        currentTime: false,
        adjustProgressEvent: 'setPlayerProgress',
        currentlyPlaying: false,
      }
    };
  },
  methods: {
    unloadCurrentTrack () {
      clearInterval(this.setCurrentProgress);
      this.playingTrack.pause();
      this.playingTrack.src = "";
    },
    receiveTrack (track) {
      if (this.playingTrack) {
        this.unloadCurrentTrack();
      }
      this.createTrack(track);
    },
    createTrack (track) {
      const _this = this;
      this.trackLoaded = false;
      this.trackProgressObject.currentlyPlaying = false;
      this.playingTrack = new Audio(track);
      this.playingTrack.oncanplaythrough = () => {
        _this.trackLoaded = true;
        _this.trackProgressObject.duration = this.playingTrack.duration;
        _this.trackProgressObject.currentTime = this.playingTrack.currentTime || 0;
      }
    },
    play () {
      const _this = this;
      this.playingTrack.play();
      this.trackProgressObject.currentlyPlaying = true;
      this.setCurrentProgress = setInterval(() => {
        if (_this.trackProgressObject.currentTime === _this.trackProgressObject.duration) {
          return clearInterval(_this.setCurrentProgress);
        }
        _this.trackProgressObject.currentTime = this.playingTrack.currentTime;
      }, 100);
    },
    pauseTrack () {
      this.playingTrack.pause();
      this.trackProgressObject.currentlyPlaying = false;
    },
    handlePlayerClick () {
      if (this.playingTrack.paused) {
        return this.play();
      }
      this.pauseTrack();
      
    },
    setVolume (volume) {
      this.playingTrack.volume = volume;
      this.$forceUpdate();
    }
  },
  created () {
    bus.$on("sendTrackToPlayer", this.receiveTrack);
    bus.$on("volumeAdjustment", this.setVolume);
  },
};
</script>

<style scoped>
  .player {
    width: 75%;
  }
  .player-button {
    border: none;
    background: none;
    min-height: 30px;
    cursor: pointer;
    padding: 0;
  }
  .player-button:focus {
    outline: none;
  }
  .disabled {
    opacity: .5;
  }
</style>